import gql from 'graphql-tag';

export const subUserEvent = gql`subscription userEvent { userEvent }`;
export const subConsumerEvent = gql`subscription consumerEvent { consumerEvent }`;